module.exports = __webpack_public_path__ + "static/media/13. Speaker Shri-C-S-R-Murthy.91274669.png";